var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "close-on-content-click": false,
        "nudge-width": 200,
        "offset-x": "",
        "max-width": "250",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "div",
                { staticClass: "pl-1" },
                [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b({ attrs: { icon: "" } }, "v-btn", attrs, false),
                      on
                    ),
                    [
                      _c("v-icon", { attrs: { medium: "", color: "black" } }, [
                        _vm._v(" fa fa-question-circle "),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "px-4" },
        [
          _c("p", { staticClass: "font-weight-bold pt-3" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.getViewTooltips[_vm.viewId].title) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "my-4 text-caption" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.getViewTooltips[_vm.viewId].description) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary", text: "" },
                  on: { click: _vm.onViewVideo },
                },
                [_vm._v(" Ver video ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }